import { render, staticRenderFns } from "./DefaultGraphQL.vue?vue&type=template&id=4334d872&scoped=true"
import script from "./DefaultGraphQL.vue?vue&type=script&lang=js"
export * from "./DefaultGraphQL.vue?vue&type=script&lang=js"
import style0 from "./DefaultGraphQL.vue?vue&type=style&index=0&id=4334d872&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4334d872",
  null
  
)

export default component.exports